import { call, put, takeLatest } from 'redux-saga/effects'
import { FETCH_TOPICS } from './constants'
import { fetchTopics } from './actions'
import { apiFetchTopics } from './services'

function* fetchHelpfulTopicWorker(action) {
  let response = yield call(apiFetchTopics, action.phoneId)

  if (Array.isArray(response)) {
    response = response.filter(
      (item) => item.contentType === 'faq' || item.contentType === 'tutorial'
    )

    response = response.map((item) => ({ ...item, contentId: item.contentKey }))

    yield put(fetchTopics.success(response))
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_TOPICS.REQUEST, fetchHelpfulTopicWorker)
}
